import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { elementAt } from 'rxjs/operators';
import { SpraRentalAmcvParams, SpraRentalPL, SpraRentalPLCalculation } from 'src/app/Models/ops';

@Component({
  selector: 'app-spra-rental-pl',
  templateUrl: './spra-rental-pl.component.html',
  styleUrls: ['./spra-rental-pl.component.css']
})
export class SpraRentalPLComponent implements OnInit {
  public spraRentalPL:SpraRentalPL;  
  public SpraRentalPLCalculation:SpraRentalPLCalculation;
  public CounterDetail:Array<SpraRentalAmcvParams>
  constructor( private cookieService:CookieService,
    private dialogRef: MatDialogRef<SpraRentalPLComponent>,        
    @Inject(MAT_DIALOG_DATA) public data:any) { 
      this.spraRentalPL = new SpraRentalPL();
      this.SpraRentalPLCalculation = new SpraRentalPLCalculation();
      this.CounterDetail = new Array<SpraRentalAmcvParams>();
    }

  ngOnInit(): void {

    if(this.data != undefined){
      this.spraRentalPL = this.data.spraRentalPL;
      this.CounterDetail = this.data.CounterDetail; 
    }
    this.spraRentalPL.InterestPL = this.spraRentalPL.InterestCostForPL;   
    this.SpraRentalPLCalculation.spraRentalPL =  this.spraRentalPL;
    this.SpraRentalPLCalculation.ConvertMachineLifeToYears();
    this.SpraRentalPLCalculation.CalculateRevenue(this.CounterDetail);

  }


}
